import React from "react";
import CustomTotal from "./customTotal";
import { withNamespaces } from "react-i18next";

const sizePerPageRenderer = ({
  options,
  currSizePerPage,
  onSizePerPageChange,
  t,
}) => (
  <div className="btn-group" role="group">
    <div className="prefix-text">Registos por página</div>
    {options.map((option) => {
      const isSelect = currSizePerPage === `${option.page}`;
      return (
        <button
          key={option.text}
          type="button"
          onClick={() => onSizePerPageChange(option.page)}
          className={`btn ${isSelect ? "btn-primary" : "btn-link"}`}
        >
          {option.text}
        </button>
      );
    })}
  </div>
);

export const pagination = {
  paginationSize: 4,
  pageStartIndex: 0,
  // alwaysShowAllBtns: true, // Always show next and previous button
  // withFirstAndLast: false, // Hide the going to First and Last page button
  // hideSizePerPage: true, // Hide the sizePerPage dropdown always
  // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page

  //firstPageText: 'First',
  //prePageText: 'Back',
  //nextPageText: 'Next',
  //lastPageText: 'Last',
  //nextPageTitle: 'First page',
  //prePageTitle: 'Pre page',
  //firstPageTitle: 'Next page',
  //lastPageTitle: 'Last page',
  showTotal: true,
  paginationTotalRenderer: CustomTotal,
  disablePageTitle: true,
  sizePerPageRenderer,
  sizePerPageList: [
    {
      text: "10",
      value: 10,
    },
    {
      text: "20",
      value: 20,
    },
    {
      text: "50",
      value: 50,
    },
    {
      text: "100",
      value: 100,
    },
  ], // A numeric array is also available. the purpose of above example is custom the text
};
export default withNamespaces()(pagination);
